module.exports = __webpack_public_path__ + "static/parade-2019-house18-8a8bc4a5329a6f74c856656fd88277b8.jpg";